import * as yup from "yup";
import { AddMainProductFormValues } from "./types";

export const defaultFormValues: AddMainProductFormValues = {
  id: "",
  variantParentId: "",
  selectedOptions: [],
};

export const schema = yup.object().shape({
  id: yup.string().required("Product is required"),
  variantParentId: yup.string().required("Variant is required"),
});
